import algoliasearch from "algoliasearch";
import envDataConfig from "../../../EnvDataConfig/EnvDataConfig";

const SearchClient = algoliasearch(
    envDataConfig.AlgoliaAppId,
    envDataConfig.AlgoliaApiKey
);
export default SearchClient;